export default function fakeSelect ($el, options) {
  const label = $el.querySelector('.label')
  const dropdown = $el.querySelector('select')
  
  label.innerHTML = dropdown.options[dropdown.selectedIndex].text
  
  dropdown.addEventListener('change', () => {
    label.innerHTML = dropdown.options[dropdown.selectedIndex].text
  })
}


// WEBPACK FOOTER //
// ./src/js/components/fake-select.js